import api from './interceptor';

const BASE_URL_V3 = 'api/v3/patients-import';

export default {
  // API Version 3
  getTemplate: () => api.get(`${BASE_URL_V3}/template`),
  deleteTemplate: importId => api.delete(`${BASE_URL_V3}/${importId}`),
  // add-google-cloud-storage-bucket
  // Delete this line after testing
  // doUploads: params => api.post(`${BASE_URL_V3}`, params),
  doUploads: params => api.post(`${BASE_URL_V3}/through-ui`, params),
  // add-google-cloud-storage-bucket
  // Delete this line after testing
  // doUploads834: (clinicId, params) => api.post(`${BASE_URL_V3}/file-834/${clinicId}`, params),
  getUploads: params => api.get(`${BASE_URL_V3}`, { params }),
  getImportErrors: (importId, params) => api.get(`${BASE_URL_V3}/${importId}`, { params }),
  fixErrors: (importId, params) => api.put(`${BASE_URL_V3}/${importId}`, params),
  getUploadedFile: importId => api.get(`${BASE_URL_V3}/${importId}/file`, { responseType: 'blob' }),
};
